import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=67af008f&scoped=true&"
import script from "./Merchants.vue?vue&type=script&lang=ts&"
export * from "./Merchants.vue?vue&type=script&lang=ts&"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=67af008f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af008f",
  null
  
)

component.options.__file = "Merchants.vue"
export default component.exports